<template>
  <div class="modal-card">
    <CloseIcon :size="24" class="close-modal-icon close-on-click" />
    <div class="modal-card-header">
      <h1 class="title">Deactivate User</h1>
    </div>
    <div class="modal-card-body">
      <p class="warning-text">Are you sure you want to deactivate <strong>{{ user.name }}</strong>?</p>

      <div class="info-section">
        <div class="info-card warning-card">
          <span class="info-label">This will</span> prevent the user from logging in and remove them from selection dropdowns.
        </div>
        <div class="info-card safe-card">
          <span class="info-label">This will not</span> delete any tickets, records, or patient data they are associated with.
        </div>
      </div>
    </div>
    <div class="modal-card-footer">
      <button class="button secondary form-button close-on-click" @click="handleCancel">
        Cancel
      </button>
      <button class="button danger form-button" @click="handleSubmit" :disabled="isSubmitting">
        {{ isSubmitting ? 'Deactivating...' : 'Deactivate User' }}
      </button>
    </div>
    <div v-if="error" class="modal-error">
      {{ error }}
    </div>
  </div>
</template>

<script>
import CloseIcon from 'vue-material-design-icons/Close.vue';
import * as api from '@/api';

export default {
  name: "DeleteUserModal",
  components: {
    CloseIcon
  },
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  emits: ['close', 'user-deleted'],
  data() {
    return {
      isSubmitting: false,
      error: null
    }
  },
  methods: {
    handleCancel() {
      // Close modal via close-on-click class
    },
    async handleSubmit() {
      this.error = null;
      this.isSubmitting = true;

      try {
        await api.deleteUser(this.user.userId);
        this.$emit('user-deleted');
      } catch (err) {
        console.error('Failed to delete user:', err);
        this.error = err.message || 'Failed to delete user';
        this.isSubmitting = false;
      }
    }
  }
}
</script>

<style scoped>
.warning-text {
  color: #595959;
  font-size: 14px;
  line-height: 1.5;
}

.info-section {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.info-card {
  font-size: 13px;
  line-height: 1.5;
  padding: 10px 12px;
  border-radius: var(--border-radius);
}

.info-label {
  font-weight: 600;
}

.warning-card {
  background: #fef3c7;
  color: #92400e;
}

.safe-card {
  background: #ecfdf5;
  color: #065f46;
}

.button.danger {
  background-color: #cf1322;
  color: white;
  border-color: #cf1322;
}

.button.danger:hover {
  background-color: #a8071a;
  border-color: #a8071a;
}

.button.danger:disabled {
  background-color: #ffccc7;
  border-color: #ffccc7;
  cursor: not-allowed;
}
</style>
